export default function DOM_Accessing() {
  return (
    <div>
      <h1>DOM_Accessing</h1>
      <p>This is the DOM_Accessing component.</p>
    </div>
  );
}